export const loginApi = '/auth/login/in'
export const sms_send = '/auth/smsCode'
export const logoutApi = '/auth/oauth/logout'
export const  role = '/corporate/university/teacher/grade/role/userRole'
export const  wechatQrCode = '/auth/login/wechatParams'
export const  wechatLogin = '/auth/login/in/wechat'
export const  wechatBind = '/auth/login/wechatBind'
